import React, { Component } from "react";
import {getTimeInIST, format_fancy, format_date_only_new, formatNumber, toInt} from '../Utils'
import moment from 'moment';
import { withStyles, Grid, Fade, CircularProgress, Table, TableBody, TablePagination, Icon, IconButton, Typography } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Paper from '@material-ui/core/Paper';
import { Color } from "../Constants";
import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import EnhancedTableHead from "../components/EnhancedTableHead";
import { RowCountOptions } from "../Config";
import { DeliveryService } from "../Services/DeliveryService";
import XLSX from 'xlsx';
import UploadedDocumentsView from "../components/UploadedDocumentsView";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3)
    },
    tablecell: {
        fontSize: '30pt',
        padding: 2
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    paperToggle: {
        display: 'flex',
        border: `1px solid ${theme.palette.divider}`,
        flexWrap: 'wrap',
      },
      divider: {
        margin: theme.spacing(1, 0.5),
      },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
            marginTop: theme.spacing(3),
        },
        float: 'left'
    },
    section: {
		width: '100%',
		minHeight: 400,
		overflow: 'auto',
		overflowX: 'auto',
		paddingTop : theme.spacing(1), 
		paddingLeft: theme.spacing(1), 
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1)
    },
    table: {
        height: 300,
        overflow: 'auto'
    }, 
    selectRoot: {
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
});

const StyledToggleButtonGroup = withStyles((theme) => ({
    grouped: {
        margin: theme.spacing(0.5),
        border: 'none',
        '&:not(:first-child)': {
            borderRadius: theme.shape.borderRadius,
        },
        '&:first-child': {
            borderRadius: theme.shape.borderRadius,
        },
    },
}))(ToggleButtonGroup);

class Invoice extends Component {

    constructor(props) {
      super(props);
      this.state = {       
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        showSpinner: false,
        invoice_rows: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        columns : [
            { id: 'sl_no', numeric: false, disablePadding: false, label: 'Sl.no', sortable: false },
            { id: 'invoice_no', numeric: false, disablePadding: false, label: 'Invoice No' , sortable: false },
            { id: 'schedule_date', numeric: false, disablePadding: false, label: 'Schedule Date' , sortable: false },
            { id: 'store_name', numeric: false, disablePadding: false, label: 'Store', sortable: false  },
            { id: 'route', numeric: false, disablePadding: false, label: 'Route', sortable: false  },
            { id: 'agent_name', numeric: false, disablePadding: false, label: 'Agent', sortable: false  },
            { id: 'delivered_count', numeric: true, disablePadding: true, label: 'Delivered Count' , sortable: false },
            { id: 'returned_count', numeric: false, disablePadding: false, label: 'Returned Count' , sortable: false },
            { id: 'total_amount', numeric: true, disablePadding: false, label: 'Total Amount' , sortable: false },
            { id: 'grn', numeric: false, disablePadding: false, label: 'GRN' , sortable: false },
            { id: 'documents', numeric: true, disablePadding: false, label: 'View Uploads' , sortable: false },
            { id: 'delivery_date', numeric: false, disablePadding: false, label: 'Delivered Date' , sortable: false }
        ],
        order: 'desc',
        orderBy: 'modified_date',
        filter: '',
        export_loading: false,
        dialog_id: undefined,
        dialog_open: false,
        pending_uploads: 0,
        pending_grns: 0,
        selected_option: 'all',
        total: 0
      }
    }

    componentDidMount(){
        this.props.setTitle('View Invoices & Credit Notes');
        this.fetchTotalPages();
        this.props.showProgressDialog();
    }

    fetchTotalPages(){
        let {startDate, endDate, selected_option} = this.state;
        DeliveryService.getTotalInvoices(startDate, endDate, selected_option)
        .then((data) => {
            let co = (selected_option === 'upload' ?  toInt(data.pending_uploads) : selected_option === 'grn' ? toInt(data.pending_grns) : data.count);
            this.setState({
                total: data.count,
                totalItems: co, 
                totalPages: Math.ceil( co / this.state.numItemsPerPage) - 1,
                pending_uploads: data.pending_uploads ? data.pending_uploads : 0, 
                pending_grns: data.pending_grns ? data.pending_grns : 0 
            });
            if(data.count > 0) {
                this.fetchData(0, this.state.numItemsPerPage);
            } else {
                this.setState({invoice_rows: [], message: "No Invoices"});
                this.props.closeProgressDialog();
            }
        })
        .catch(error => {
            console.log(error);
        });
    }

    handleChangeStartDate = (date) => {
        this.setState({
            startDate: date,
        }, () => this.fetchTotalPages());
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchTotalPages());
    }

    handleSelect = (eventKey, e) => {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }   
        }
    }

    fetchRow = (newCurrentPage) => {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    sortBy = (event, property) => {
        // const orderBy = property;
        // let order = 'desc';
    
        // if (this.state.orderBy === property && this.state.order === 'desc') {
        //   order = 'asc';
        // }
    
        // this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value, currentPageNumber: 0 }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    filterCriteria = (e) => {
        let searchText = "";
        if(e){
            e.preventDefault();
            searchText = e.target.value || "";
        }
        this.setState({filter : searchText}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    fetchData = (start, numberItems) => {
        let {startDate, endDate, selected_option} = this.state;
        this.props.showProgressDialog();
        let invoice_rows = [];

        DeliveryService.getInvoices(startDate, endDate, start, numberItems, selected_option)
        .then((data) => {
            console.log(data);
            if(data.invoices){
                data.invoices.forEach((invoice, index) => {
                    invoice_rows.push(<InvoiceDetails index={index + 1  + start} key={invoice.invoice_no} invoice={invoice} viewDocuments={this.viewDocuments}/>);
                });
            }
            this.setState({invoice_rows, message: data.invoices.length > 0 ? "" : "No Invoices"});
            this.props.closeProgressDialog();
        })
        .catch(error => {
            console.log(error);
            this.props.closeProgressDialog();
        });
    }

    viewDocuments = (id) => {
        this.setState({dialog_id: id, dialog_open: true});
	}

    exportReport = () => {
        let {totalItems, startDate, endDate} = this.state;
        this.setState({export_loading: true});
        if(totalItems > 0){
            let sheetname = 'Store Invoice Report';
            let exportData = [];

            let title = ["Sl No", "Invoice No", "Credit Note No", "Schedule Date", "Store", "Route", "Agent", "Deliveried Count", "Returned Count", "Total Amount", "Delivered Date"];
            exportData.push(title);

            DeliveryService.getInvoices(startDate, endDate, 0, totalItems)
            .then((data) => {
                if(data.invoices){
                    data.invoices.forEach((invoice, index) => {
                        let row = [++index, invoice.invoice_no, invoice.credit_note_no ? invoice.credit_note_no : "-", getTimeInIST(invoice.schedule_date).format(format_date_only_new), invoice.store_name, invoice.route_id, invoice.agent_name, toInt(invoice.delivered_count), toInt(invoice.returned_count), parseFloat(invoice.total_amount), getTimeInIST(invoice.delivery_date).format(format_fancy)];
                        exportData.push(row);
                    });
                    if(exportData){
                        const wb = XLSX.utils.book_new();
                        const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                        XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                        XLSX.writeFile(wb, sheetname + ".xlsx");
                    }
                }
                this.setState({export_loading: false});
            })
            .catch(error => {
                console.log(error);
                this.setState({export_loading: false});
            });
        } else {
            this.props.showSnackBar('Nothing to export', 'error');
            this.setState({export_loading: false});
        }
    }

    filterRows = (event, option) => {
        if(option && option.length > 0){
            this.setState({selected_option : option}, () => this.fetchTotalPages());
        }
    };
    
    render() {
        let { total, order, orderBy, columns, export_loading, totalItems, numItemsPerPage, currentPageNumber, startDate, endDate, message, showSpinner, invoice_rows, dialog_id, dialog_open, pending_uploads, pending_grns, selected_option} = this.state;
        const { classes } = this.props;
        return ( 
            <div className="Home">
                <Grid container spacing={2} style={{marginTop: 20}}>
                    <Grid item xs={12} lg={4}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                variant="dialog"
                                margin="normal"
                                label="From"
                                value={startDate}
                                onChange={this.handleChangeStartDate}
                                format='DD MMM YYYY'
                                maxDate={endDate}
                                inputVariant="outlined"
                                className={classes.formControl}
                            />
                            <DatePicker
                                variant="dialog"
                                margin="normal"
                                label="To"
                                value={endDate}
                                minDate={startDate}
                                onChange={this.handleChangeEndDate}
                                format='DD MMM YYYY'
                                inputVariant="outlined"
                                className={classes.formControl}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                    <Paper style={{paddingTop : 15, paddingLeft: 10, paddingRight: 10, marginTop: 10}}>
                        <Grid container spacing={2} justify="flex-start" alignItems="center">
                            <Grid item xs={6} lg={2}>
                                <Typography variant="subtitle2">
                                    Total Invoices
                                </Typography>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Typography align="left" variant="subtitle2">
                                    {total}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Typography variant="subtitle2">
                                    Uploads Pending
                                </Typography>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Typography align="left" variant="subtitle2" color="primary" style={{cursor:"pointer"}}>
                                    {pending_uploads}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Typography variant="subtitle2">
                                    GRN Pending
                                </Typography>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Typography align="left" variant="subtitle2" color="primary" style={{cursor:"pointer"}}>
                                    {pending_grns}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} lg={6}>
                                <Paper elevation={0} className={classes.paperToggle}>
                                    <Grid component="label" justify="center" container alignItems="center" spacing={1}>
                                        <Grid item>
                                            <Typography variant="caption">
                                                Filter:
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <StyledToggleButtonGroup 
                                                size="small" 
                                                value={selected_option} 
                                                onChange={this.filterRows} 
                                                exclusive 
                                                aria-label="small outlined button group">
                                                    <ToggleButton value={'all'}>All</ToggleButton>
                                                    <ToggleButton value={'upload'}>Upload Pending</ToggleButton>
                                                    <ToggleButton value={'grn'}>GRN Pending</ToggleButton>
                                            </StyledToggleButtonGroup>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper className={classes.root} style={{paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", marginTop: '10px'}}>
                            <EnhancedTableToolbar title="Invoices" exportReport={this.exportReport} showProgress loading={export_loading}/>
                                <Table padding="none" size="small" style={{maxHeight: 500, overflow: 'auto', display: 'inline-block'}}>
                                    <EnhancedTableHead
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={this.sortBy}
                                        rows ={columns} />
                                    <TableBody>
                                    {invoice_rows}
                                    </TableBody>
                                </Table>
                                { message &&
                                    <div style={{backgroundColor: 'white', color:"red", paddingTop:50}}>{message}</div>
                                }
                                <TablePagination
                                    rowsPerPageOptions={RowCountOptions}
                                    component="div"
                                    count={totalItems}
                                    rowsPerPage={numItemsPerPage}
                                    page={currentPageNumber}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    classes={{ selectRoot : classes.selectRoot}}
                                    />
                        </Paper>
                    </Grid>
                </Grid>
                <Fade
                  key="spinner"
                  in={showSpinner}
                  style={{
                    transitionDelay: showSpinner ? '10ms' : '0ms',
                    position: 'absolute', left: '50%', top: '60%'
                  }}
                  unmountOnExit
                  >
                  <CircularProgress style={{marginTop: 20, color: Color.green}} color="inherit" size={60}/>
                </Fade>
                <UploadedDocumentsView id={dialog_id} open={dialog_open} close={() => this.setState({dialog_open: false})}/>
            </div>
        );
    }
}

function InvoiceDetails(props){

    const {invoice, index, viewDocuments} = props;

    
    const classes = {
        tablecell: {
            fontSize: '10pt',
            padding: 2
        },
        tablecellAction: {
            fontSize: '10pt',
            padding: 2,
            color: 'blue',
            cursor: 'pointer',
            width: 120
        }
    }

    function openLink(link){
        if(link.length > 0){
            window.open(link, "_blank")
        }
    }
    
    return (
        <tr>
            <td style={classes.tablecell}>{index}</td>
            <td align="center" style={invoice.invoice_url ? classes.tablecellAction: {}} onClick={() => invoice.invoice_url && openLink(invoice.invoice_url)}>
                {invoice.delivered_count > 0 ? invoice.invoice_no : '-'}
            </td>
            <td align="center" style={classes.tablecell}>{getTimeInIST(invoice.schedule_date).format(format_date_only_new)}</td>
            <td align="left" style={classes.tablecell}>{invoice.store_name}</td>
            <td align="justify" style={classes.tablecell}>{invoice.route_id ? invoice.route_id : "-"}</td>
            <td align="center" style={classes.tablecell}>{invoice.agent_name ? invoice.agent_name : '-'}</td>
            <td align="right" style={classes.tablecell}>{invoice.delivered_count ? invoice.delivered_count : '-'}</td>
            <td align="center" style={classes.tablecell}>
                    {invoice.returned_count ? invoice.returned_count : '-'}
                    {invoice.credit_note_no ? <span style={classes.tablecellAction} onClick={() => openLink(invoice.credit_note_url)}><br/>{invoice.credit_note_no}</span> : ''}
            </td>
            <td align="center" style={classes.tablecell}>{invoice.total_amount ? formatNumber(invoice.total_amount) : '-'}</td>
            <td>{invoice.grn || '-'}</td>
            <td align="center" style={classes.tablecell}>
                <IconButton disabled={toInt(invoice.count_uploaded_docs) === 0} onClick={(e) => viewDocuments(invoice.invoice_no)} >
                    <Icon>{toInt(invoice.count_uploaded_docs) === 0 ? "cloud_off" : "cloud_upload"}</Icon>
                </IconButton>
            </td>
            <td align="right" style={classes.tablecell}>{getTimeInIST(invoice.delivery_date).format(format_fancy)}</td>
        </tr>
    );
}

export default withStyles(styles)(Invoice);